import React from "react"
import WelcomeFamilyImg from "../../../images/welcome-family.svg"

const Hero = () => {
  return (
    <section className="container mx-auto md:mt-20 px-6 pb-12">
        <div className="flex flex-col-reverse md:flex-row items-center">
      <div className="flex-1 md:w-1/2 md:pr-4">
        <h1 className="text-5xl lg:text-7xl font-light mb-8 leading-tight">
          <span className="text-secondary font-bold block">Welcome</span>
          to the family
        </h1>
        <p className="pb-4 text-2xl"><span className="font-bold">Remember to keep your Resume or Portfolio updated.</span></p>
        <p className="pb-4 text-xl">Here you will find active job searches to be part of this family and also the positions that have already been taken by the new members.</p>
        <p className="pb-12"><span className="font-bold">Don’t miss out and subscribe to our mailing list so you get the updates!</span></p>
      </div>
      <div className="flex-1 my-8 md:my-0 w-full md:w-1/2">
        <img
          src={WelcomeFamilyImg}
          alt="¿Estás listo para emprender el viaje?"
          className="mx-auto"
          width="500"
        />
      </div>
    </div>
    </section>
  )
}

export default Hero
